/**
 * ColorPickerContext  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { ISchemaStringWithConstConstItem } from "@adapptio/lib-blueprint";
import { COLOR_CODE_TYPE } from "./ColorPickerTypes";

export interface IColorPickerContextValue {
	palette?: ISchemaStringWithConstConstItem[];
	value?: string;
	valueFromPalette?: string;
	pickedColor?: string;
	onChange?: (value: string) => void;
	onClose?: () => void;
	codeType?: COLOR_CODE_TYPE;
}

export const ColorPickerContext = React.createContext<IColorPickerContextValue>({});

export function useColorPickerContext(): IColorPickerContextValue {
	return useContext(ColorPickerContext);
}
